import dayjs from "dayjs";
// import { isSomething } from "../../../../utils/utils";

// Helper function to normalize dates to "YYYY-MM-DD" format
export const normalizeDate = (dateString) => {
    // If the date is in ISO format (e.g., "2024-09-11T18:00:00.000Z"), extract the date part
    if (dateString.includes('T')) {
        return dateString.split('T')[0]; // Only take the "YYYY-MM-DD" part
    }

    // If it's already in "YYYY-MM-DD" format, return it as-is
    return dateString;
  };
  
export const parseScheduleValue = (value) => {
    if (typeof value === "string") {
        // Remove commas and convert to a float
        const sanitizedValue = value.replace(/,/g, "");
        const parsedValue = parseFloat(sanitizedValue);
        return isNaN(parsedValue) ? 0 : parsedValue; // Default to 0 if parsing fails
    }
    if (typeof value === "number") {
        return value; // Return as-is if already a number
    }
    return 0; // Fallback to 0 for unexpected types
};
  
  
export const alignScheduleToStartMonth = (startMonth, schedule) => {
const alignedSchedule = [];

// Ensure startMonth is a Date object (assuming it is passed as a Date object)
const startDate = new Date(startMonth);

schedule.forEach((item) => {
    // Get year and month from the start date
    const startYear = startDate.getUTCFullYear();
    const startMonthIndex = startDate.getUTCMonth(); // 0-indexed month (Jan is 0)

    // Calculate correct month and year without month shifting errors
    const monthIndex = startMonthIndex + item.month;
    const yearOffset = Math.floor(monthIndex / 12);
    const actualMonth = monthIndex % 12;

    // Create the aligned date using UTC
    const date = new Date(Date.UTC(startYear + yearOffset, actualMonth, 1));

    const value = parseScheduleValue(item.value);
    if (!isNaN(value)) {
    alignedSchedule.push({ date, value });
    }
});

return alignedSchedule;
};
  
export const calculateFilterRange = (rangeStartDate, rangeNoOfMonths, format = "MMM-YYYY") => {
const startDate = new Date(rangeStartDate);
const filtersRange = Array.from({ length: rangeNoOfMonths }, (_, index) => {
    const date = new Date(startDate.getFullYear(), startDate.getMonth() + index, 1);
    return dayjs(date).format(format);
});
return filtersRange;
};

  
export const isProjectScheduleWithinRange = (schedule, startDate, filtersRange, format = "MMM-YYYY") => {
const projectStartDate = normalizeDate(startDate); // Normalize the date
const scheduleRange = alignScheduleToStartMonth(projectStartDate, schedule);
const formattedSchedule = scheduleRange?.map((x) =>
    dayjs(x?.date).format(format)
);

const commonElements = filtersRange.filter((value) =>
    formattedSchedule.includes(value)
);

return commonElements.length > 0;
};
